import React from "react";

import "../CheckBox.scss";
const checkBox = (props) => (
  <div className="pr-2">
    <input
      type="checkbox"
      className="custom-checkbox"
      checked={props.checked}
      onChange={props.selectAllHandler}
      onClick={(e) => e.stopPropagation()}
    />
  </div>
);

export default checkBox;
